import { isNil } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import { useParams } from 'react-router';

import { CircularProgress } from '@mui/material';

import useIsMobile from 'hooks/use-is-mobile';
import LoginNotification from 'pages/components/LoginNotification';
import ErrorPage from 'pages/ErrorPage';

import AsideSection from './components/AsideSection';
import BulletinDetails from './components/BulletinDetails';
import useBulletin from './hooks/use-bulletin';
import { HistoryOfChangesProvider } from './providers/history-of-changes';
import useStyles from './styles';

const Bulletin: React.FC = () => {
    const { classes } = useStyles();

    const { itemId } = useParams<{ itemId: string }>();

    const isMobile = useIsMobile();
    const bulletin = useBulletin(itemId);

    if (bulletin.isLoading) {
        return (
            <div className={classes.spinner}>
                <CircularProgress />
            </div>
        );
    }

    if (isNil(bulletin.data)) {
        return <ErrorPage status={404} description="Not found" />;
    }

    return (
        <HistoryOfChangesProvider id={bulletin.data.id}>
            <div className={classes.root}>
                <BulletinDetails isMobile={isMobile} data={bulletin.data} />
                {isMobile ? null : <AsideSection data={bulletin.data} />}
            </div>
            <LoginNotification />
        </HistoryOfChangesProvider>
    );
};

export default observer(Bulletin);
